Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-cart-searchbox');

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);

        var $list = $('.x-cart-searchbox-results', $wrapper);

        if ($wrapper.length < 1 || $list.length < 1) return;

        var model = {},
            resultsPerPage = $wrapper.attr('data-page-size') || 12,
            maxResults = parseInt(resultsPerPage) > 0 ? parseInt(resultsPerPage) : 12,
            pdPageNum = 1,
            isProductSelected = false,
            isLookupCompleted = false,
            list = $list.get(0),
            $searchInput = $('.js-keyword', $wrapper),
            $qtyInput = $('.js-quantity', $wrapper),
            $increaseQtyInput = $('.js-incr-quantity', $wrapper),
            $decreaseQtyInput = $('.js-decr-quantity', $wrapper),
            $submitButton = $('.js-add-to-cart', $wrapper),
            minLength = parseInt($wrapper.attr('data-min-search-length')) || 1;

        var lazyLoadPrices = $wrapper.attr('data-lazyload-prices');
        if (typeof lazyLoadPrices === 'string') {
            lazyLoadPrices = lazyLoadPrices.trim().toLowerCase() === 'true';
        }

        wrapper.loading = function loading(loading) {
            isLookupCompleted = !loading;
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            }
        };

        wrapper.enableInput = function enableInput(enable, $input) {
            if (enable) {
                $input.removeAttr('disabled').prop('disabled', false);
            } else {
                $input.attr('disabled', 'disabled').prop('disabled', true);
            }
        };

        wrapper.enableInputs = function enableInputs(enable) {
            wrapper.enableInput(false, $decreaseQtyInput);
            wrapper.enableInput(enable, $increaseQtyInput);
            wrapper.enableInput(enable, $qtyInput);
            wrapper.enableInput(enable, $submitButton);
        };

        list.update = function update() {
            wrapper.loading(true);

            var html = Vendd.Handlebars.parse("cartSearchBoxResults_A", model);
            var $html = $(html);
            var $newProducts = $('.product-results', $html);
            var $products = $('.product-results', $list).last();

            if ($products.length > 0) {
                $newProducts.insertAfter($products);
            } else {
                $html.appendTo($list);
            }
                
            if (!model.MoreProducts) {
                $('.js-more-results', $list).hide();
            }

            wrapper.loading(false);
        };

        list.clear = function clear() {
            $list.html("");
        };

        list.show = function show(show) {
            if (show) {
                $wrapper.addClass('active');
                $list.addClass("js-visible");
            } else {
                $wrapper.removeClass('active');
                $list.removeClass("js-visible");
            }
        };

        wrapper.checkSearchTerm = function (searchTerm) {
            return /[a-zα-ωάέήίόύώϊϋΐΰςа-я0-9]+/i.test(searchTerm);
        };

        wrapper.setSelectedProduct = function setSelectedProduct(data) {
            var productId = (data) ? data.productId : '',
                variantId = (data) ? data.variantId : '',
                path = (data) ? data.path : '',
                availabilityActionId = (data) ? data.availabilityActionId : '',
                name = (data) ? data.name : '',
                stock = (data) ? data.stock : 0,
                minQuantity = (data) ? data.minQuantity : 0,
                maxQuantity = (data) ? data.maxQuantity : 0,
                quanta = (data) ? data.quanta : 0,
                color = (data) ? data.color : "",
                size = (data) ? data.size : "",
                list = (data) ? data.list : "";

            $searchInput.attr('data-productid', productId);
            $searchInput.attr('data-variantid', variantId);
            $searchInput.attr('data-path', path);
            $searchInput.attr('data-availability-action-id', availabilityActionId);
            $searchInput.attr('data-min-quantity', minQuantity);
            $searchInput.attr('data-max-quantity', maxQuantity);
            $searchInput.attr('data-quanta', quanta);
            $searchInput.attr('data-color', color);
            $searchInput.attr('data-size', size);
            $searchInput.attr('data-list', list);
            if (name != "") $searchInput.val(name);
            $qtyInput.attr('data-stock', stock);

            var quantity = stock > minQuantity ? minQuantity : 1;
            if (quantity > 0 && quanta > 0 && quantity % quanta !== 0) {
                quantity = quanta;
            }

            $qtyInput.val(numberToString(quantity));

            wrapper.enableInputs(stock > 0);
            isProductSelected = (data) ? true : false;
        };

        $list.on('click', '.js-list-item', function () {
            var $item = $(this);
            var data = {
                productId: $item.attr('data-productid').toString(),
                variantId: $item.attr('data-variantid').toString(),
                path: $item.attr('data-path').toString(),
                availabilityActionId: $item.attr('data-availability-action-id').toString(),
                name: $item.attr('data-name'),
                stock: parseInt($item.attr('data-stock')),
                minQuantity: parseFloat(($item.attr('data-min-quantity') ? stringToNumber($item.attr('data-min-quantity')) : null) || 1),
                maxQuantity: parseFloat(($item.attr('data-max-quantity') ? stringToNumber($item.attr('data-max-quantity')) : null) || $item.attr('data-stock')),
                quanta: parseFloat(($item.attr('data-quanta') ? stringToNumber($item.attr('data-quanta')) : null) || 1),
                color: $item.attr('data-color') ? $item.attr('data-color') : "",
                size: $item.attr('data-size') ? $item.attr('data-size') : "",
                list: $item.attr('data-list') ? $item.attr('data-list') : ""
            };

            wrapper.setSelectedProduct(data);
            list.show(false);

            if ($('.x-orderchangeform').length > 0) {
                $item.closest('[data-container="orderItem"]').find("[name='replaceWith']").val(data.variantId);
                $item.closest('[data-container="orderItem"]').attr('data-validationEngine').validate('replaceWith');
            }

        });

        $list.on('click', '.js-more-results', function () {
            var searchTerm = $searchInput.val();
            if ($searchInput.val().length >= minLength && !isProductSelected) {
                pdPageNum++;
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm, pdPageNum, maxResults));
            } else {
                list.show(false);
            };
        });

        $wrapper.on('click', '.js-incr-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.attr('data-stock'));

            var quanta = parseFloat(($searchInput.attr('data-quanta') ? stringToNumber($searchInput.attr('data-quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.attr('data-min-quantity') ? stringToNumber($searchInput.attr('data-min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.attr('data-max-quantity') ? stringToNumber($searchInput.attr('data-max-quantity')) : null) || stock);

            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));

            if (isNaN(tempQuantity)) tempQuantity = minQuantity;

            if (tempQuantity >= 0) {
                tempQuantity = tempQuantity + quanta;

                if (tempQuantity <= maxQuantity) {
                    wrapper.enableInput(tempQuantity !== maxQuantity, $increaseQtyInput);
                    $qtyInput.val(numberToString(tempQuantity));
                } else {
                    wrapper.enableInput(false, $increaseQtyInput);
                }

                if (tempQuantity > minQuantity) wrapper.enableInput(true, $decreaseQtyInput);
            }

            var enableSubmitButton = (parseFloat(stringToNumber($qtyInput.val())) > 0 && isProductSelected);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        $wrapper.on('click', '.js-decr-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.attr('data-stock'));
            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));
            var quanta = parseFloat(($searchInput.attr('data-quanta') ? stringToNumber($searchInput.attr('data-quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.attr('data-min-quantity') ? stringToNumber($searchInput.attr('data-min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.attr('data-max-quantity') ? stringToNumber($searchInput.attr('data-max-quantity')) : null) || stock);

            if (tempQuantity !== minQuantity && tempQuantity > 0) {
                tempQuantity = tempQuantity - quanta;
                $qtyInput.val(numberToString(tempQuantity));
                wrapper.enableInput(true, $increaseQtyInput);
            }

            if (tempQuantity <= minQuantity) wrapper.enableInput(false, $decreaseQtyInput);

            var enableSubmitButton = (parseFloat(stringToNumber($qtyInput.val())) > 0 && isProductSelected);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        $wrapper.on('keyup', '.js-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.attr('data-stock'));

            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));
            var quanta = parseFloat(($searchInput.attr('data-quanta') ? stringToNumber($searchInput.attr('data-quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.attr('data-min-quantity') ? stringToNumber($searchInput.attr('data-min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.attr('data-max-quantity') ? stringToNumber($searchInput.attr('data-max-quantity')) : null) || stock);

            if (quanta > 1 && tempQuantity % quanta !== 0) {
                tempQuantity = tempQuantity - (tempQuantity % quanta);
            }

            var selectedQuantity = tempQuantity;

            if (tempQuantity < maxQuantity && tempQuantity > minQuantity) {
                selectedQuantity = tempQuantity;
            } else if (tempQuantity >= maxQuantity) {
                selectedQuantity = quanta > 1 && maxQuantity % quanta !== 0 ? maxQuantity - (maxQuantity % quanta) : maxQuantity;
            } else if (tempQuantity <= minQuantity) {
                selectedQuantity = quanta > 1 && minQuantity % quanta !== 0 ? minQuantity - (minQuantity % quanta) : minQuantity;
            } else {
                //if qty is NaN
                if (minQuantity) {
                    selectedQuantity = minQuantity;
                } else if (quanta) {
                    selectedQuantity = quanta;
                } else {
                    selectedQuantity = 1;
                }
            }

            var enableIncreaseQtyInput = (selectedQuantity < maxQuantity),
                enableDecreaseQtyInput = (selectedQuantity > minQuantity),
                enableSubmitButton = (selectedQuantity >= minQuantity && selectedQuantity <= maxQuantity && isProductSelected);

            wrapper.enableInput(enableIncreaseQtyInput, $increaseQtyInput);
            wrapper.enableInput(enableDecreaseQtyInput, $decreaseQtyInput);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        $wrapper.on('keydown', '.js-quantity', function (e) {
            numbersOnly(e);
        });

        $wrapper.on('click', '.js-add-to-cart', function (e) {
            if ($searchInput.val().length >= minLength && isLookupCompleted && isProductSelected) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);

                if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                    return;

                if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                    return;

                var id = $searchInput.attr('data-productid');
                var skuId = $searchInput.attr('data-variantid');
                var path = $searchInput.attr('data-path');
                var qty = parseFloat(stringToNumber($qtyInput.val())) || 1;
                var extraAttributes = [];
                var bundleItems = [];
                var recipeItems = [];
                var comboItems = [];
                var itemInfo = {
                    minQuantity: parseFloat(($searchInput.attr('data-min-quantity') ? stringToNumber($searchInput.attr('data-min-quantity')) : null) || 0),
                    maxQuantity: parseFloat(($searchInput.attr('data-max-quantity') ? stringToNumber($searchInput.attr('data-max-quantity')) : null) || 0),
                    quanta: parseFloat(($searchInput.attr('data-quanta') ? stringToNumber($searchInput.attr('data-quanta')) : null) || 0),
                };

                //enhanced info
                var color = $searchInput.attr('data-color');
                var size = $searchInput.attr('data-size');
                var list = $searchInput.attr('data-list');
                var enhancedInfo = { color: color, size: size, list: list };

                //set quantity if is empty
                $qtyInput.val(qty);

                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            };
        });

        $wrapper.on('keyup', '.js-keyword', $.debounce(850, function () {
            var searchTerm = $searchInput.val();

            //reset
            if (isProductSelected) wrapper.setSelectedProduct(null);
            list.clear();
            pdPageNum = 1;

            if (searchTerm.length >= minLength && wrapper.checkSearchTerm(searchTerm)) {
                wrapper.loading(true);
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm, pdPageNum, maxResults));
            } else {
                list.show(false);
            }
        }));

        $wrapper.on('click', '.js-keyword', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $searchInput.select();
        });

        $wrapper.on('focus', '.js-keyword', function () {
            var show = ($searchInput.val().length >= minLength && isLookupCompleted && !isProductSelected);
            list.show(show);
        });

        $wrapper.on('click', '.js-search-toggle', function (e) {
            if (!$wrapper.hasClass('active')) return;

            list.show(false);
        });

        Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed, wrapper, function (envelope) {
            list.show(false);
            wrapper.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess, wrapper, function (envelope) {
            if (envelope.message.data.sender !== wrapper) return;

            model = envelope.message.data.model;

            //check if current user has custom prices
            var currentUser = Vendd.User && Vendd.User.GetClientModel();
            var customPrices = currentUser && currentUser.HasCustomPrices;
            model.LazyLoadPrices = lazyLoadPrices || customPrices;

            model.MoreProducts = ((((model || {}).hits || {}).total || {}).value || 0) > (maxResults * pdPageNum);

            if (pdPageNum > 1) model.PageNumber = pdPageNum;

            if (model.LazyLoadPrices && model.hits.hits.length > 0) {
                var items = model.hits.hits.map(function (x) { return x._source }).map(function (y) { return y.VariantId });
                var obj = {
                    itemIds: items,
                    fetchPrices: true,
                    fetchAvailabilities: false,
                    fetchStock: false
                };
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(obj));

                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper, function (envelope) {
                    var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);

                    //extend model
                    model.B2BModel = { ...{}, ...result.B2B};
                    model.ShowPriceWithoutVat = result.ShowPriceWithoutVat;

                    var modelWithPrices = model.hits.hits.forEach(function (obj) {
                        var selectedProduct = result.Products.find(function (x) { return obj._source.VariantId === x.VariantId; });
                        if (selectedProduct) obj._source = { ...obj._source, ...selectedProduct.Prices };

                        if (obj._source['Flags']) {
                            var flags = obj._source['Flags'],
                                arrayFlags = [];
                            for (var p in flags) {
                                arrayFlags.push({ 'Key': p, 'Value': flags[p] });
                            }
                            obj._source['Flags'] = arrayFlags;
                        }
                    });
                    model.hits.hits = { ...model.hits.hits, ...modelWithPrices };

                    list.update();
                    list.show(true);
                    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper);
                });
            } else {
                list.update();
                list.show(true);
            }
        });

        $(document).mouseup(function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                list.show(false);
            }
        });

    });
});